import React, { ReactElement } from "react";
import utilityBarStyles from './AlmeUtilityBar.styles';
import { Box, Button, Container, useMediaQuery } from "@material-ui/core";
import { WithStyles, withStyles, useTheme } from '@material-ui/core/styles';
import { FocusComponentProps } from "../../models/ComponentProps";
import { AlmeUtilityBarConfig, UtilityBarItem } from "./AlmeUtilityBarConfig";
import ALmeUtilityBarItem from './AlmeUtilityBarItem';

interface AlmeUtilityBarProps extends WithStyles<typeof utilityBarStyles> {
    almeConfig: AlmeUtilityBarConfig;
    focusProps?: FocusComponentProps;
    onUtilityLinkClick: () => void;
}


function createUtilityItem(item: UtilityBarItem, props: AlmeUtilityBarProps, key: number): ReactElement {
    if (item.links.length === 1) {
        return <Button
            id={`alme-utility-button-${key}`}
            href={item.links[0].href}
            target={item.links[0].target}
            className={props.classes.utilityBarButton}
            key={key}
            size={"small"}
            onClick={item.links[0].target === "_self" ? props.onUtilityLinkClick : undefined}>
            {item.links[0].label}
        </Button>;
    }
    return (
        <ALmeUtilityBarItem almeConfig={props.almeConfig} links={item.links} title={item.title} key={key} onUtilityLinkClick={props.onUtilityLinkClick} />
    );
}

const AlmeUtilityBar: React.FC<AlmeUtilityBarProps> | null = (props: AlmeUtilityBarProps) => {
    const theme = useTheme();
    const shouldDisplay = useMediaQuery(theme.breakpoints.down(props.almeConfig.utilityBar.breakpoint))
        && props.almeConfig.utilityBar.isEnabled;

    if (!shouldDisplay) {
        return null;
    }
    else {
        return (
            <Container disableGutters className={props.classes.utilityBar} id="alme-utility-bar">
                <Box display={"flex"} justifyContent={"space-around"}>
                    {props.almeConfig.utilityBar.items.map((item, key) => createUtilityItem(item, props, key))}
                </Box>
            </Container>
        );
    }
};

export default withStyles(utilityBarStyles)(AlmeUtilityBar);
